import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, OnInit } from '@angular/core';
import { CarrierModule } from '../carrier/carrier';

@Component({
  selector: 'to-nose-number',
  templateUrl: './nose-number.html',
  styleUrls: ['./nose-number.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoseNumberComponent implements OnInit {
  @Input() nose: string;
  @Input() carrier: string;
  @Input() size: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h4';

  ngOnInit() {
    this.carrier = (this.carrier || '').toLowerCase();
  }

}

@NgModule({
  declarations: [
    NoseNumberComponent,
  ],
  exports: [
    NoseNumberComponent,
  ],
  imports: [
    CommonModule,
    CarrierModule,
  ]
})
export class NoseNumberModule { }
